import type { RefusalNotifiableConfig } from '@/api/api';
import type { CommentReply } from '@/types/review/ReviewAnswer';

import { api } from '@/api/api';

export interface CreateCommentReplyParams {
    /** On an anonymous 360, the stand-in its results show, which the server finds only within its evaluation. */
    reviewQuestionAnswerId: string;
    reviewInstanceId: string;
    content: string;
}

export default {
    async createCommentReply({
        reviewQuestionAnswerId,
        reviewInstanceId,
        content,
    }: CreateCommentReplyParams): Promise<CommentReply> {
        // The page says what a refusal means for the reply, which the generic toast cannot.
        const response = await api.post(
            `/commentreply`,
            { reviewQuestionAnswerId, reviewInstanceId, content },
            { notifyOnRefusal: false } as RefusalNotifiableConfig,
        );
        return response.data;
    },
};
